import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/login/auth.service';
import { UserService } from 'src/app/services/user.service';
import { MovingMoneyDoc, User } from 'src/typings';
import { environment } from 'src/environments/environment';
import { normalizeDateRangePayload } from 'src/app/shared/utils/date-filter.util';

@Injectable({
  providedIn: 'root'
})
export class MovingMoneyService {
  user: User | undefined;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService
  ) {
    this.userService.user.subscribe((user) => {
      this.user = user;
    });
  }

  search(payload: {
    date_from: Date;
    date_to: Date;
    id: number;
    user_id: number;
    bank_from_id: number;
    bank_to_id: number;
  }) {
    const normalizedPayload = normalizeDateRangePayload(payload);
    return this.http
      .post<
        {
          id: number;
          date_created: Date;
          date: Date;
          value: number;
          commission: number;
          passed: boolean;
          manager: string;
          bank_from: string;
          bank_to: string;
        }[]
      >(`${environment.BACKEND}/doc/moving-money/search`, normalizedPayload)
      .pipe(
        map((data) => {
          return data.map((obj) => {
            return (obj = { ...obj, date_created: new Date(obj.date_created) });
          });
        })
      );
  }

  getList() {
    return this.http
      .get<
        {
          id: number;
          date_created: Date;
          date: Date;
          value: number;
          commission: number;
          passed: boolean;
          manager: string;
          bank_from: string;
          bank_to: string;
        }[]
      >(`${environment.BACKEND}/doc/moving-money/list`)
      .pipe(
        map((data) => {
          return data.map((obj) => {
            return (obj = { ...obj, date_created: new Date(obj.date_created) });
          });
        })
      );
  }

  getOne(id: number) {
    return this.http.get<MovingMoneyDoc>(`${environment.BACKEND}/doc/moving-money/${id}`);
  }

  create(payload: {
    value: number;
    user_id?: number;
    date: Date;
    bank_from_id: number;
    bank_to_id: number;
    commission?: number;
  }) {
    // const user_id = this.user?.id; // @todo remove? this value never read
    return this.http.post<MovingMoneyDoc>(
      `${environment.BACKEND}/doc/moving-money/create`,
      payload
    );
  }

  save(payload: {
    id: number;
    value: number;
    passed?: boolean;
    user_id?: number;
    date: Date;
    bank_from_id: number;
    bank_to_id: number;
    commission?: number;
  }) {
    return this.http.put<MovingMoneyDoc>(`${environment.BACKEND}/doc/moving-money/save`, payload);
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/doc/moving-money/${id}`);
  }
}
